/*
Workspace widget settings (tenant-scoped):
  GET    /api/allowed-domains          -> { id, domain, addedAt }[]
  POST   /api/allowed-domains          { domain } -> { id, domain, addedAt }
  DELETE /api/allowed-domains/:id
  GET    /api/widget-installation-key  -> { key, isDemo }
The widget start call rejects an `origin` that is not on the list (403 DOMAIN_NOT_ALLOWED).
*/
import { apiClient } from "../../api/apiClient";

export const listAllowedDomains = () => apiClient("/api/allowed-domains").then((res) => res.data);

export async function addAllowedDomain(domain) {
  if (!domain) throw new Error("Enter a domain name.");
  const res = await apiClient("/api/allowed-domains", { method: "POST", body: JSON.stringify({ domain }) });
  return { ...res.data, status: "allowed", savedAt: res.data.addedAt };
}

export async function removeAllowedDomain(domainOrId) {
  if (!domainOrId) throw new Error("A domain is required.");
  await apiClient(`/api/allowed-domains/${domainOrId}`, { method: "DELETE" });
  return { id: domainOrId, status: "removed" };
}

export async function getWidgetInstallationKey() {
  const res = await apiClient("/api/widget-installation-key");
  const configured = process.env.REACT_APP_WIDGET_INSTALLATION_KEY;
  return { key: configured || res.data.key, isDemo: configured ? false : res.data.isDemo, status: "success" };
}
